export const isEligibilityPending = (eligibility) => (!eligibility?.status || eligibility.status === 'ready_to_verify');
